import { supabase } from './SupabaseClient';

export async function retrieveAccessToken() {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();

    if (sessionError) {
        throw new Error(`Failed to get session: ${sessionError.message}`);
    }

    // Use the access token from the current session
    const accessToken = session?.access_token;

    if (!accessToken) {
        throw new Error("No authentication token available");
    }
    return accessToken;
} 